import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse, Link,
} from '@material-ui/core';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import {makeStyles} from "@material-ui/styles";
import TeamLocationFields from "./pwtForm/TeamLocationFields";

const useStyles = makeStyles((theme) => ({
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));

const LocationsSection = ({ team, open, locationOptions, handleOnChangeInField, showAddLocation = true, onRemoveLocation }) => {
  const classes = useStyles();
  const [expandLocations, setExpandLocations] = useState(open);
  const [principalLocationIndex, setPrincipalLocationIndex] = useState(null);

  const toggleExpandLocations = () => {
    setExpandLocations(!expandLocations);
  }

  function handleAddNestedFields(type, nestedFieldsName) {
    let currentData = [...team[nestedFieldsName]];

    const field = {
      id: null,
      _destroy: false,
      city_id: null,
      country_id: locationOptions.unitedStatesId,
      state : null,
      address: '',
      address_2: '',
      phone: '',
      zip_code: '',
      is_principal: false,
      ignore_validation: false
    };

    currentData.push(field);
    handleOnChangeInField(nestedFieldsName, currentData);
  }

  function handleRemoveNestedFields(nestedField, nestedFieldsName) {
    nestedField._destroy = true;
    handleOnChangeInField(nestedFieldsName, team[nestedFieldsName]);
  }

  function handleNestedFieldChange(nestedFieldsName, item, field, value) {
    item._destroy = false;
    item[field] = value;
    handleOnChangeInField(nestedFieldsName, team[nestedFieldsName]);
  }

  const handleSetPrincipalLocation = (index, isSelected) => {
    const updatedLocations = team.locations?.map((location, i) => {
      if (i === index) {
        return { ...location, is_principal: isSelected };
      } else {
        return { ...location, is_principal: false };
      }
    });

    handleOnChangeInField('locations', updatedLocations);

    if (isSelected) {
      setPrincipalLocationIndex(index);
    } else {
      setPrincipalLocationIndex(null);
    }
  };

  return(
    <React.Fragment>
      <Card style={{marginTop: '24px'}}
      >
        <CardHeader className='cursor-pointer' title={
            <span>
              <span>Locations</span>
              <span className='float-right'>
                {
                  expandLocations ? <ExpandLess /> : <ExpandMore />
                }
              </span>
            </span>
          } onClick={toggleExpandLocations}
        />
        <Divider />
        <CardContent style={{padding: `${expandLocations ? '20px' : 0}`, overflowY: 'auto'}}>
          <Collapse in={!!expandLocations}>
            {
              <div className={classes.formGroup}>
                {team.locations?.map((location, index) =>
                  <TeamLocationFields
                    key={`location-edit-${index}-${location.id}`}
                    locationOptions={locationOptions}
                    location={location}
                    isPrincipal={principalLocationIndex && principalLocationIndex === index || location.is_principal}
                    handleNestedFieldChange={handleNestedFieldChange}
                    handleRemoveNestedFields={handleRemoveNestedFields}
                    handleSetPrincipalLocation={handleSetPrincipalLocation}
                    onRemoveLocation={onRemoveLocation}
                    index={index}
                    showRemoveLocation={showAddLocation}
                  />)}
                {showAddLocation &&
                  <Link to='' className={classes.addNewRelationshipLink}
                        onClick={() => handleAddNestedFields('location', 'locations')}>+ New Location Fields</Link>
                }
              </div>
            }
          </Collapse>
        </CardContent>
      </Card>
    </React.Fragment>
  )
}

export default LocationsSection;